import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useState } from 'react'
import { hoursToSeconds } from 'date-fns'
import { Card, Icon, Text } from 'src/components/ui'
import { ModelInputTag } from 'src/services'
import { TagSparkline } from 'models/model'
import { useThemeStore } from 'pages/app'
import { TagChart } from './TagChart'

type Props = {
  modelId: string
  tag: ModelInputTag
  recomendation: number | undefined
  currentValue: number | undefined
}

export function RecommendationCard({
  modelId,
  tag,
  recomendation,
  currentValue,
}: Props): JSX.Element {
  const [expanded, setExpanded] = useState(false)
  const theme = useThemeStore(state => state.getTheme)()

  return (
    <Card>
      <div className="mr-[32px] flex items-center justify-between">
        <Text bold>Tag Name</Text>
        <div className="flex items-center gap-m">
          <Text bold>Last 24 hours</Text>
          <Text bold>Current Value</Text>
          <Text bold>Recommended Value</Text>
        </div>
      </div>

      <div
        onClick={() => setExpanded(!expanded)}
        className={classNames(
          'flex items-center justify-between cursor-pointer hover:bg-background-hover transition duration-300',
          expanded ? 'py-[10px]' : 'py-[3px]',
        )}
      >
        <Text className="text-right text-text-secondary">
          {tag.node.displayName ?? tag.node.tagName}
        </Text>
        <div className="flex items-center gap-s">
          {!expanded && (
            <div className="h-[32px] w-[140px]">
              <TagSparkline
                id={tag.node.tagName}
                periodSeconds={hoursToSeconds(24)}
                color={theme.charts.prescriptive.actual}
              />
            </div>
          )}
          <Text className="w-[90px] text-right text-text-secondary">
            {currentValue !== undefined
              ? Math.round(currentValue * 100) / 100
              : 'N/A'}
          </Text>
          <Text
            className={classNames('w-[142px] text-text-secondary text-right')}
          >
            {recomendation !== undefined
              ? Math.round(recomendation * 100) / 100
              : 'N/A'}
          </Text>

          <Icon
            icon={light('chevron-down')}
            className={expanded ? 'rotate-180' : ''}
          />
        </div>
      </div>

      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.1 }}
            className="py-m"
          >
            <TagChart modelId={modelId} tag={tag.node} />
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  )
}
